import { render, staticRenderFns } from "./RateDetail.vue?vue&type=template&id=06fb7fc8&scoped=true&"
import script from "./RateDetail.vue?vue&type=script&lang=js&"
export * from "./RateDetail.vue?vue&type=script&lang=js&"
import style0 from "./RateDetail.vue?vue&type=style&index=0&id=06fb7fc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb7fc8",
  null
  
)

export default component.exports